/**
 * 结算订单状态
 */
export enum SettleOrderStatus {
    Default = '',
    // Initial = 0,// 发起汇款
    Processing = 10, // 资料审核中
    ReSubmitting = 11, // 待重新提交纸质资料
    TurnDown = 12, // 驳回
    Submitting = 20, // 提交材料中
    BankAuditing = 30, // 银行审核中
    BankAgree = 31, // 银行审核成功
    BankReject = 32, // 银行拒绝
    Cancel = 40, // 订单取消
}
